import React from 'react'
import { useState,useEffect } from 'react'
import Addnewparent from './addnewparent';
import ApiUrl from  '../../../../configTools/apiUrl'
import Itemsearchscreen from './itemsearchscreen';

const Index = () => {
    const [allcategoryList,setAllCategoryList] = useState([]);
    const [searchs,setSearchs] = useState([]);
    const getSearchScreens = ()=>{
        fetch(ApiUrl.API_URL_SearchScreen)
        .then(res=>res.json())
        .then(data =>{
            setSearchs(data.responce);
        });

    }
    useEffect(()=>{
        fetch(ApiUrl.API_URL_Collection)
        .then(res=>res.json())
        .then(data =>{
            setAllCategoryList(data);
        });
        getSearchScreens();
    },[])
  return (
    <div className='form_container'>
        <div className='form_container'>
            <Addnewparent allcategoryList={allcategoryList} getSearchScreens={getSearchScreens}/>
            {
                searchs.map((item,index)=>{
                    return(
                        <div className='admin_forms_container'  key={index}>
                            <Itemsearchscreen Value={item} allcategoryList={allcategoryList} getSearchScreens={getSearchScreens}/>
                        </div>
                    )
                })
            }
        </div>
    </div>
  )
}

export default Index
